import { SupportedChainId } from './chain'

export const ZOOM_2_ADDRESSES = {
    [SupportedChainId.MAINNET]: "0x7cdF091AF6a9ED75E3192500d3e5BB0f63e22Dea",
    [SupportedChainId.RINKEBY]: "0x491592F30D9a3d1887F486eA2A3c72ad82fAcF4D",
    [SupportedChainId.GOERLI]: '0xebC7d793d062371C11cB802e7D49eEAA0c30EB06'
}
